const renderUnitChoices = (relationships, isOptional = false) => {
    console.log(
        "renderUnitChoices",
        relationships[0]?.parent_record?.value,
        isOptional
    );

    if (!relationships?.length) {
        return "";
    }

    return relationships
        .sort((a, b) => Number(a.order) - Number(b.order))
        .filter(rel =>
            rel.academic_item_code ||
            rel.academic_item_credit_points ||
            rel.academic_item_name
        )
        .map((rel, index, arr) => `
            <div class="unit-row--wrap">
                <div class="unit-row--details">
                    ${
                        rel.academic_item_code
                            ? `
                                <p>
                                    <a href="https://api.murdoch.edu.au/handbook/v2/gotohandbook/${rel.academic_item_code}" target="_blank"><span>${rel.academic_item_code}</span></a>
                                </p>
                            `
                            : ""
                    }

                    ${
                        rel.academic_item_credit_points
                            ? `
                                <p>
                                    <span>${rel.academic_item_credit_points}</span>
                                </p>
                            `
                            : ""
                    }

                    ${
                        rel.academic_item_name
                            ? `
                                <p>
                                    <span>${rel.academic_item_name}</span>
                                </p>
                            `
                            : ""
                    }
                </div>
            </div>
            ${
                isOptional && index < arr.length - 1
                    ? `<div class="optional">or</div>`
                    : ""
            }
        `)
        .join("");
};

const renderDescription = (description) => {
    if (!description?.trim()) {
        return "";
    }

    return `
        <div class="alert-box alert-box--secondary">
            <small>${description}</small>
        </div>
    `;
};

const renderConditionLinks = (container, courseCode) => {
    if (!container.condition_set?.length) {
        return "";
    }

    return `
            <p>
                Please refer to the <a href="https://api.murdoch.edu.au/handbook/v2/gotohandbook/${courseCode}">handbook</a> for further information.
            </p>
        `;
};

const renderContainer = (container, courseCode) => {
    let content = "";

    // Description first
    content += renderDescription(container.description);

    // Condition set links
    content += renderConditionLinks(container, courseCode);

    // Child containers
    if (container.container?.length) {
        content += container.container
            .sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
            .map(child => renderContainer(child, courseCode))
            .join("");
    }

    // Relationships
    if (container.relationship?.length) {
        const isOptional = container.relationship?.some(
            rel => rel.parent_connector?.value === "OR"
        );

        content += renderUnitChoices(
            container.relationship,
            isOptional
        );
    }

    return `
        <details
            class="accordion mu-accordion"
            data-unit-set="${container.vertical_grouping?.value || ""}"
            data-unit-title="${container.title || ""}">

            <summary class="mu-accordion-header">
                <h5>
                    ${container.title || ""}
                    <span class="lead">
                        ${container.credit_points || 0} Credit Points
                    </span>
                </h5>
            </summary>

            <div class="accordion-body mu-accordion-body">
                <div class="mu-accordion-body-inner">
                    ${content}
                </div>
            </div>
        </details>
    `;
};

const initCourseStructureAccordion = () => {
    if (typeof getStructure !== "function") {
        console.warn("getStructure() not available");
        return;
    }

    let structure = getStructure();

    if (!structure) {
        return;
    }

    if (Array.isArray(structure)) {
        structure = structure[0];
    }

    const target = document.querySelector(
        "#course-structure-accordion"
    );

    if (!target) {
        return;
    }

    if (!structure?.container?.length) {
        target.innerHTML = `
            <p>No course structure available.</p>
        `;
        return;
    }

    const courseCode = structure.cl_id?.value;

    target.innerHTML = structure.container
        .sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
        .map(container => renderContainer(container, courseCode))
        .join("");
};

export default initCourseStructureAccordion;